import loadable from '@loadable/component';
import Loading from '../components/Loader';

const BunningsOnboarding = loadable(
  () => import(/* webpackChunkName: "onboarding" */ '../containers/BunningsOnboarding'),
  {
    fallback: Loading
  }
);

export default BunningsOnboarding;
